<template>
  <div style="position: relative;">
    <el-form ref="commentAuditFilter" :model="commentAudit" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="审核状态" prop="formFilter.auditFlag">
          <el-select class="filter-item" v-model="commentAudit.formFilter.auditFlag" :clearable="true" filterable
            placeholder="" :loading="commentAudit.auditFlag.impl.loading"
            @visible-change="commentAudit.auditFlag.impl.onVisibleChange"
            @change="onAuditFlagValueChange">
            <el-option v-for="item in commentAudit.auditFlag.impl.dropdownList" :key="item.id"
              :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="内容" prop="formFilter.searchString">
          <el-input class="filter-item" v-model="commentAudit.formFilter.searchString"
                    :clearable="true" placeholder="内容"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetCommentAudit">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshCommentAudit(true)">查询</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="moreAudit('1')">批量审核通过</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="moreAudit('-1')">批量审核不通过</el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="comment" :data="commentAudit.Comment.impl.dataList" :size="defaultFormItemSize" @sort-change="commentAudit.Comment.impl.onSortChange"
          header-cell-class-name="table-header-gray"
          highlight-current-row @current-change="commentAudit.Comment.impl.currentRowChange"
                  @selection-change="handleSelectionChange"
        >
          <el-table-column header-align="center"
                           align="center" type="selection" width="50px"
          />
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="commentAudit.Comment.impl.getTableIndex" />
          <el-table-column label="创建人名称" prop="createdUserName">
          </el-table-column>
          <el-table-column label="回复内容" prop="commentContent">
          </el-table-column>
<!--          <el-table-column label="图片" prop="attachedImages">
          </el-table-column>-->
          <el-table-column label="审核状态" prop="auditStatusDictMap.name">
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime">
<!--            <template slot-scope="scope">-->
<!--              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>-->
<!--            </template>-->
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button @click.stop="onUpdateAuditClick(scope.row, '1')" type="text" :size="defaultFormItemSize"
                         v-if="scope.row.auditStatus === '0'"
                :disabled="!checkPermCodeExist('commentAudit:commentAudit:updateAudit')">
                审核通过
              </el-button>
              <el-button @click.stop="onUpdateAuditClick(scope.row, '-1')" type="text" :size="defaultFormItemSize"
                         v-if="scope.row.auditStatus === '0'"
                :disabled="!checkPermCodeExist('commentAudit:commentAudit:updateAudit')">
                审核不通过
              </el-button>
              <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                         v-if="scope.row.auditStatus !== '0'"
                         :disabled="!checkPermCodeExist('commentAudit:commentAudit:updateAudit')">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="commentAudit.Comment.impl.totalCount"
            :current-page="commentAudit.Comment.impl.currentPage"
            :page-size="commentAudit.Comment.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="commentAudit.Comment.impl.onCurrentPageChange"
            @size-change="commentAudit.Comment.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { CommentController, DictionaryController } from '@/api';

export default {
  name: 'commentAudit',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      commentAudit: {
        formFilter: {
          auditFlag: undefined,
          searchString: undefined
        },
        formFilterCopy: {
          auditFlag: undefined,
          searchString: undefined
        },
        auditFlag: {
          impl: new DropdownWidget(this.loadAuditFlagDropdownList)
        },
        Comment: {
          impl: new TableWidget(this.loadCommentWidgetData, this.loadCommentVerify, true, true, 'createTime', 1)
        },
        isInit: false
      },
      multiSelect: []
    }
  },
  methods: {
    /**
     * 批量审核
     */
    moreAudit (status) {
      if (this.multiSelect.length === 0) {
        this.$message.error('请至少勾选一条数据！');
      } else {
        let params = {
          commentList: this.multiSelect,
          status: status
        };

        CommentController.updateAudit(this, params).then(res => {
          this.$message.success('操作成功');
          this.commentAudit.Comment.impl.refreshTable(false, 1);
        }).catch(e => {});
      }
    },
    /**
     * 选中的值
     */
    handleSelectionChange (values) {
      console.log('values', values)
      this.multiSelect = values;
    },
    onResetCommentAudit () {
      this.$refs.commentAuditFilter.resetFields();
      this.refreshCommentAudit(true);
    },
    /**
     * 评论表数据获取函数，返回Promise
     */
    loadCommentWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        commentDtoFilter: {
          auditStatus: this.commentAudit.formFilterCopy.auditFlag,
          searchString: this.commentAudit.formFilterCopy.searchString
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        CommentController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.commentAudit.Comment.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.commentAudit.Comment.impl.currentRow.id, 'id');
              this.$refs.comment.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 评论表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadCommentVerify () {
      this.commentAudit.formFilterCopy.auditFlag = this.commentAudit.formFilter.auditFlag;
      this.commentAudit.formFilterCopy.searchString = this.commentAudit.formFilter.searchString;
      return true;
    },
    /**
     * 审核状态下拉数据获取函数
     */
    loadAuditFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAuditStatusDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 审核状态选中值改变
     */
    onAuditFlagValueChange (value) {
    },
    /**
     * 更新评论审核
     */
    refreshCommentAudit (reloadData = false) {
      if (reloadData) {
        this.commentAudit.Comment.impl.refreshTable(true, 1);
      } else {
        this.commentAudit.Comment.impl.refreshTable();
      }
      if (!this.commentAudit.isInit) {
        // 初始化下拉数据
      }
      this.commentAudit.isInit = true;
    },
    /**
     * 审核通过
     */
    onUpdateAuditClick (row, status) {
      let comment = {
        id: row.id
      }
      this.multiSelect.push(comment);
      let params = {
        commentList: this.multiSelect,
        status: status
      };

      CommentController.updateAudit(this, params).then(res => {
        this.$message.success('操作成功');
        this.commentAudit.Comment.impl.refreshTable(false, 1);
      }).catch(e => {});
    },
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      CommentController.delete(this, params).then(res => {
        this.$message.success('删除成功');
        this.commentAudit.Comment.impl.refreshTable(false, 1);
      }).catch(e => {});
    },
    onResume () {
      this.refreshCommentAudit();
    },
    initFormData () {
    },
    formInit () {
      this.refreshCommentAudit();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
